import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ScrollPanelModule } from 'primeng/scrollpanel';
import { TooltipModule } from 'primeng/tooltip';

import { LocalizationModule } from '../../Core/Localization/localization.module';
import { PanelComponent } from './components/Panel/panel.component';
import { ScrollPanelComponent } from './components/ScrollPanel/scroll-panel.component';
import { InitiallyFocusableDirective } from './directives/initially-focusable.directive';
import { TooltipDirective } from './directives/tooltip.directive';
import { TooltipCursorDirective } from './directives/tooltip-cursor.directive';

@NgModule({
    imports: [
        CommonModule,
        ScrollPanelModule,
        LocalizationModule,
        TooltipModule,
    ],
    declarations: [
        ScrollPanelComponent,
        PanelComponent,
        TooltipDirective,
        TooltipCursorDirective,
        InitiallyFocusableDirective
    ],
    exports: [
        ScrollPanelComponent,
        PanelComponent,
        TooltipDirective,
        TooltipCursorDirective,
        InitiallyFocusableDirective
    ],
    providers: [
    ]
})
export class CommonBasicModule {

}
